/** @jsxImportSource react */
import { useEffect, useState } from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

/** A PDF Blob shown in the page (desktop browsers), with an "Open" link for phones and full screen. */
const PdfPreview = ({ blob, height = 560, title = 'Document preview' }) => {
  const [url, setUrl] = useState(null)
  useEffect(() => {
    if (!blob) return undefined
    const objectUrl = URL.createObjectURL(blob)
    setUrl(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [blob])
  if (!url) return null
  return (
    <Stack spacing={1}>
      <Box component="iframe" title={title} src={url}
        sx={{ width: '100%', height: { xs: 360, md: height }, border: 1, borderColor: 'divider', borderRadius: 1, bgcolor: 'common.white' }} />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="caption" color="text.secondary">Can’t see it? Open it in a new tab.</Typography>
        <Button size="small" startIcon={<OpenInNewIcon />} href={url} target="_blank" rel="noopener noreferrer">Open</Button>
      </Stack>
    </Stack>
  )
}

export default PdfPreview
